import Vue from 'vue';
import {Formatter, SYSTEM_DATE_FORMAT} from "@/core/services/formatter.service";

function getMonthAgo(model_date) {
  const date = model_date ? new Date(model_date) : new Date()
  date.setMonth(date.getMonth() - 1)
  date.setDate(1)
  return Formatter.toDate(date, SYSTEM_DATE_FORMAT)
}

function getMonthCurrent(model_date) {
  const date = model_date ? new Date(model_date) : new Date()
  date.setMonth(date.getMonth() + 1)
  date.setDate(0)
  return Formatter.toDate(date, SYSTEM_DATE_FORMAT)
}

Vue.directive('get-month-ago', {
  inserted: getMonthAgo,
  updated: getMonthAgo,
  componentUpdated: getMonthAgo
});

Vue.directive('get-month-current', {
  inserted: getMonthCurrent,
  updated: getMonthCurrent,
  componentUpdated: getMonthCurrent
});

export {
  getMonthAgo, getMonthCurrent
}
